module.exports = __webpack_public_path__ + "img/logo-lifeapps.4a7b02e0.png";